import { createContext } from "react";

const AddTagsContext = createContext();

export default AddTagsContext;
